module.exports = __webpack_public_path__ + "static/ilustracePohreb3-c2aa9849b77d5ba58b11cc783c8d5a56.svg";